const PROD = true;

module.exports.API_URL = PROD ? 'https://aerandir-wiki-dckorlljb-demianmyrddin.vercel.app/api/' : 'http://localhost:3000/api/'